import {Routes} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {RecipeComponent} from './components/recipe/recipe.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {RegistrationComponent} from './components/registration/registration.component';
import {authenticationGuard} from './guards/authentication/authentication.guard';
import {USER_ROLES} from './constants/roles/roles.const';
import {roleGuard} from './guards/role/role.guard';
import {LoginComponent} from './components/login/login.component';
import {ProfileComponent} from './components/patient/profile/profile.component';
import {AppAdministrationComponent} from './components/app-administration/app-administration.component';
import {PatientFileForDoctorComponent} from './components/patient-file-for-doctor/patient-file-for-doctor.component';
import {DoctorDashboardComponent} from './components/doctor-dashboard/doctor-dashboard.component';
import {ContactComponent} from './components/contact/contact.component';
import {PatientFileComponent} from './components/patient/patient-file/patient-file.component';
import {TermsAndConditionsComponent} from './components/terms/terms-and-conditions/terms-and-conditions.component';
import {DataProtectionComponent} from './components/terms/data-protection/data-protection.component';
import {ImpressumComponent} from './components/terms/impressum/impressum.component';
import {DoctorSelectionComponent} from './components/appointment-booking/doctor-selection/doctor-selection.component';
import {DoctorSettingsComponent} from './components/doctor-settings/doctor-settings.component';
import {DoctorAppointmentsComponent} from './components/doctor-appointments/doctor-appointments.component';
import {DoctorPatientsListComponent} from './components/doctor-patients-list/doctor-patients-list.component';
import {AppointmentComponent} from './components/appointment-booking/appointment-selection/appointment.component';
import {AppointmentDetailsComponent} from './components/appointment-booking/appointment-details/appointment-details.component';
import {AppointmentBookingDetailsComponent} from './components/appointment-booking/appointment-booking-details/appointment-booking-details.component';
import {
    FollowingPrescriptionComponent
} from './components/prescription/following-prescription/following-prescription.component';
import {
    ForgotPasswordPageComponent
} from './components/service-pages/forgot-password-page/forgot-password-page.component';
import {ConfirmMailPageComponent} from './components/service-pages/confirm-mail-page/confirm-mail-page.component';
import {AboutUsComponent} from './components/info/about-us/about-us.component';
import {FaqComponent} from './components/info/faq/faq.component';

import {LandingLayoutComponent} from './layouts/landing-layout/landing-layout.component';
import {AppLayoutComponent} from './layouts/app-layout/app-layout.component';
import {PatientRecipeComponent} from './components/patient/patient-recipe/patient-recipe.component';
import {PatientDashboardComponent} from './components/patient/patient-dashboard/patient-dashboard.component';

export const routes: Routes = [
    {
        path: '',
        component: LandingLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                component: HomeComponent,
                title: 'Home'
            },
            {
                path: 'registrierung',
                component: RegistrationComponent,
                title: 'Registrierung'
            },
            {
                path: 'anmeldung',
                component: LoginComponent,
                title: 'Anmelden'
            },
            {
                path: 'kontakt',
                component: ContactComponent,
                title: 'Kontakt'
            },
            {
                path: 'agb',
                component: TermsAndConditionsComponent,
                title: 'AGB'
            },
            {
                path: 'datenschutz',
                component: DataProtectionComponent,
                title: 'Datenschutz'
            },
            {
                path: 'impressum',
                component: ImpressumComponent,
                title: 'Impressum'
            },
            {
                path: 'faq',
                component: FaqComponent,
                title: 'FAQ'
            },
            {
                path: 'ueber-uns',
                component: AboutUsComponent,
                title: 'Über Uns'
            },
            {
                path: 'passwort-zuruecksetzen/:uuid',
                component: ForgotPasswordPageComponent,
                title: 'Passwort zurücksetzen'
            },
            {
                path: 'email-bestaetigen/:uuid',
                component: ConfirmMailPageComponent,
                title: 'E-Mail bestätigen'
            },
            {
                path: 'email-bestaetigen/:registerToken/validate',
                component: ConfirmMailPageComponent,
                title: 'E-Mail bestätigen'
            },
        ]
    },
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [authenticationGuard],
        children: [
            {
                path: 'termine/arztwahl',
                component: DoctorSelectionComponent,
                title: 'Arztwahl',
            },
            {
                path: 'termine/buchung',
                component: AppointmentBookingDetailsComponent,
                title: 'Termin buchen',
            },
            {
                path: 'profil-uebersicht',
                component: PatientDashboardComponent,
                title: 'Übersicht',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Patient]
                }
            },
            {
                path: 'doctor-dashboard',
                component: DoctorDashboardComponent,
                title: 'Dashboard',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
            {
                path: 'profil',
                component: ProfileComponent,
                title: 'Profil',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Patient]
                }
            },
            {
                path: 'termine',
                component: AppointmentComponent,
                title: 'Termine',
            },
            {
                path: 'termine/:id',
                component: AppointmentDetailsComponent,
                title: 'Termindetails',
            },
            {
                path: 'administration',
                component: DoctorSettingsComponent,
                title: 'Einstellungen',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
            {
                path: 'termin-administration',
                component: DoctorAppointmentsComponent,
                title: 'Termine',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
            {
                path: 'patienten-liste',
                component: DoctorPatientsListComponent,
                title: 'Patienten',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
            {
                path: 'rezepte',
                component: RecipeComponent,
                title: 'Rezepte',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
            {
                path: 'patient-rezepte',
                component: PatientRecipeComponent,
                title: 'Meine Rezepte',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Patient]
                }
            },
            {
                path: 'folgerezept',
                component: FollowingPrescriptionComponent,
                title: 'Folgerezept',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Patient]
                }
            },
            {
                path: 'app-administration',
                component: AppAdministrationComponent,
                title: 'ADMIN BEREICH',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Admin]
                }
            },
            {
                path: 'meine-akte',
                component: PatientFileComponent,
                title: 'Patientenakte',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Patient]
                }
            },
            {
                path: 'patientenakte',
                component: PatientFileForDoctorComponent,
                title: 'Patientenakte',
                canActivate: [roleGuard],
                data: {
                    role: [USER_ROLES.Doctor]
                }
            },
        ]
    },
    {
        path: 'not-found',
        component: NotFoundComponent,
        title: 'Seite nicht gefunden'
    },
    {
        path: '**',
        redirectTo: 'not-found',
        title: 'Seite nicht gefunden'
    }
];
